import hairbanner from "./images/hairbanner.jpg";
import "./stylesheet/homepage.scss";
import "./stylesheet/animation.scss";

import map from "./images/googlemapzoom.png";
import entrance from "./images/entrance.jpg";
import entrance2 from "./images/entrance2.jpg";
import hairwash from "./images/hairwash.jpg";

import {FadeinscrollComponent} from "./components/FadeinscrollComponent";

import React, { useState, useEffect } from "react";
import {ScrollButton} from "./components/ScrollButton";

function App() {
  const [notTop, setnotTop] = useState(false);

    // For button scroll up
    useEffect(() => {
      const onScroll = e => {
        if (window.pageYOffset >= 0 && window.pageYOffset < 140) {
          setnotTop(false);     
        } else {
          setnotTop(true);
        }
      };
      onScroll();
      window.addEventListener("scroll", onScroll);
      // unmount
      return ()=>window.removeEventListener("scroll", onScroll);
    }, []);

  return (
    <div className="App">
      <header>
        <FadeinscrollComponent aniStyle="fadein-effect">
          <h1>Ha's Hair Salon</h1>
        </FadeinscrollComponent>
        <FadeinscrollComponent aniStyle="fadein-effectDelay">
          <div className="container-inner-header">
            <div id="banner">
              <img src={hairbanner} alt="hairbanner" />
            </div>
            <div className="info"> Providing local haircuts since 2003</div>
          </div>
        </FadeinscrollComponent>
      </header>
      <main>
        <FadeinscrollComponent aniStyle="fadein-effect">
          <section className="container-location-hour">
            <section className="location">
              <div>
                <h2>Location</h2>
                <ul>
                  <li>Surrey, BC</li>
                  <li>14947 98 Ave</li>
                  <li>V3R5W9</li>
                </ul>
                <button>
                  <a href="https://www.google.com/maps/dir//Ha's+Hair+Salon,+14947+98+Ave,+Surrey,+BC+V3R+5W9/@49.1806747,-122.8103707,17z/data=!4m16!1m6!3m5!1s0x5485d768476ec8c5:0xab9cbb0258f48d16!2sHa's+Hair+Salon!8m2!3d49.180675!4d-122.8081819!4m8!1m0!1m5!1m1!1s0x5485d768476ec8c5:0xab9cbb0258f48d16!2m2!1d-122.8081819!2d49.180675!3e4">
                    Get Directions
                  </a>
                </button>
              </div>
            </section>
            <section>
              <h2>To Book/Inquiries</h2>
              <ul>
                <li>Home Phone: 604-583-7206</li>
                <li>Mobile: 604-353-7215</li>
              </ul>
            </section>
            <section className="hours">
              <h2>Hours</h2>
              <ul>
                <li>Closed on Holidays</li>
                <li>Monday: 8:30 AM - 6:00 PM</li>
                <li>Tuesday: 8:30 AM - 6:00 PM</li>
                <li>Wednesday: 8:30 AM - 6:00 PM</li>
                <li>Thursday: 8:30 AM - 6:00 PM</li>
                <li>Friday: 8:30 AM - 6:00 PM</li>
                <li>Saturday: Closed</li>
                <li>Sunday: Closed</li>
              </ul>
            </section>
            <section>
              <h2>Services Offered</h2>
              <ul>
                <li>Mens Hair Cut</li>
                <li>Womens Hair Cut</li>
                <li>Kids Hair Cut</li>
                <li>Shampoo set</li>
                <li>Perm</li>
                <li>Coloring</li>
                <li>Streak High Light</li>
              </ul>
            </section>
          </section>
        </FadeinscrollComponent>
        <FadeinscrollComponent aniStyle="fadein-effect">
          <div className="container-img">
                <img src={map} alt="map" />
          </div>
        </FadeinscrollComponent>
      </main>
      <FadeinscrollComponent aniStyle="slideup-effect">
        <section className="container-collage">
          <div><img src={entrance} alt="entrance-salon" /></div>
          <div><img src={entrance2} alt="entrance-tilt-salon" /></div>
          <div><img src={hairwash} alt="hairwash-salon" /></div>
        </section>
      </FadeinscrollComponent>
      {
        notTop  && <ScrollButton/> 
      } 
    </div>
    
  );
}

export default App;
